"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _util = require("../../../util");

var css = _interopRequireWildcard(require("./ScripTable.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The ScripTable component is used to show scrips in table format
 */
const ScripTable = /*#__PURE__*/React.forwardRef(({
  scrips,
  nameLabel,
  chartLabel,
  priceLabel,
  changeLabel,
  volumeLabel,
  ...otherProps
}, ref) => (0, _pragma.createFelaElement)(_.Table, _extends({
  borderCollapse: "separate",
  borderSpacing: [0, 'xsmall'],
  ref: ref
}, otherProps), (0, _pragma.createFelaElement)(_.TableHead, {
  dividerPartial: true
}, (0, _pragma.createFelaElement)(_.TableRow, null, (0, _pragma.createFelaElement)(_.TableCell, {
  css: css.emptyCell,
  padding: 0
}), (0, _pragma.createFelaElement)(_.TableCell, {
  padding: 0
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta",
  color: "text.2"
}, nameLabel)), (0, _pragma.createFelaElement)(_.TableCell, null, (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta",
  color: "text.2"
}, chartLabel)), (0, _pragma.createFelaElement)(_.TableCell, {
  align: "right"
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta",
  color: "text.2"
}, priceLabel)), (0, _pragma.createFelaElement)(_.TableCell, {
  align: "right"
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta",
  color: "text.2"
}, changeLabel)), (0, _pragma.createFelaElement)(_.TableCell, {
  align: "right"
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta",
  color: "text.2"
}, volumeLabel)), (0, _pragma.createFelaElement)(_.TableCell, null), (0, _pragma.createFelaElement)(_.TableCell, null), (0, _pragma.createFelaElement)(_.TableCell, {
  css: css.emptyCell,
  padding: 0
}))), (0, _pragma.createFelaElement)(_.TableBody, null, scrips.map(({
  id,
  onClick,
  onBuy,
  onSell,
  scripName,
  scripDate,
  exchange,
  graphData,
  graphVariant,
  lastPrice,
  change,
  volume,
  selected,
  onSelectClick
}) => (0, _pragma.createFelaElement)(_.TableRow, {
  onClick: onClick,
  key: id,
  interactive: true,
  dividerPartial: true,
  css: css.row
}, (0, _pragma.createFelaElement)(_.TableCell, {
  css: css.emptyCell,
  padding: 0
}), (0, _pragma.createFelaElement)(_.TableCell, {
  padding: ['small', 'small', 'small', 0],
  verticalAlign: "middle"
}, (0, _pragma.createFelaElement)(_.ScripCellName, {
  scripDate: scripDate,
  scripName: scripName,
  exchange: exchange
})), (0, _pragma.createFelaElement)(_.TableCell, {
  padding: "small",
  verticalAlign: "middle"
}, graphData && (0, _pragma.createFelaElement)(_.LineGraph, {
  variant: graphVariant,
  height: 32,
  width: 72,
  data: graphData
})), (0, _pragma.createFelaElement)(_.TableCell, {
  padding: "small",
  verticalAlign: "middle",
  align: "right"
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "metaBold",
  color: "text.1"
}, lastPrice)), (0, _pragma.createFelaElement)(_.TableCell, {
  padding: "small",
  verticalAlign: "middle",
  align: "right"
}, (0, _pragma.createFelaElement)(_.Text, {
  color: graphVariant ? (0, _util.getColorForVariant)(graphVariant) : 'text.1',
  variant: "meta"
}, change)), (0, _pragma.createFelaElement)(_.TableCell, {
  padding: "small",
  verticalAlign: "middle",
  align: "right"
}, (0, _pragma.createFelaElement)(_.Text, {
  color: "text.1",
  variant: "meta"
}, volume)), (0, _pragma.createFelaElement)(_.TableCell, {
  padding: "small",
  verticalAlign: "middle",
  align: "right",
  width: 90
}, (0, _pragma.createFelaElement)(_.ScripCellTradingActions, {
  showChart: false,
  onBuy: onBuy,
  onSell: onSell,
  "data-name": "actions"
})), (0, _pragma.createFelaElement)(_.TableCell, {
  padding: ['small', 0],
  verticalAlign: "middle",
  align: "right",
  css: css.icon
}, (0, _pragma.createFelaElement)(_.ButtonIcon, {
  onClick: onSelectClick,
  variant: "invisible"
}, selected ? (0, _pragma.createFelaElement)(_.StarActiveIcon, {
  color: "data.yellow",
  size: "small"
}) : (0, _pragma.createFelaElement)(_.StarInactiveIcon, {
  size: "small"
}))), (0, _pragma.createFelaElement)(_.TableCell, {
  css: css.emptyCell,
  padding: 0
}))))));
ScripTable.displayName = 'ScripTable';
var _default = ScripTable;
exports.default = _default;
//# sourceMappingURL=ScripTable.js.map